import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CmsComponentsConfig } from '@app/custom/features/rrs-cms/configs/cms-components.config';
import { RrsPaginationModule } from '@app/custom/features/rrs-pagination/rrs-pagination.module';
import { RrsProductCardModule } from '@app/custom/features/rrs-product-card/rrs-product-card.module';
import {
  RrsActiveFacetsComponent,
  RrsFacetComponent,
  RrsFacetListButtonComponent,
  RrsFacetListComponent,
  RrsStoreFacetComponent,
} from '@app/custom/features/rrs-product-listing/components/rrs-facets';
import { RrsDialogActiveFacetsComponent } from '@app/custom/features/rrs-product-listing/components/rrs-facets/rrs-dialog-active-facets/rrs-dialog-active-facets.component';
import { RrsProductListingComponent } from '@app/custom/features/rrs-product-listing/components/rrs-product-listing/rrs-product-listing.component';
import { rrsViewConfig } from '@app/custom/features/rrs-product-listing/configs/rrs-view.config';
import { RrsPlpItemImageSrcPipe } from '@app/custom/features/rrs-product-listing/pipes/rrs-plp-item-image-src.pipe';
import { RrsFacetService } from '@app/custom/features/rrs-product-listing/services/rrs-facet-service/rrs-facet.service';
import { RrsProductListComponentService } from '@app/custom/features/rrs-product-listing/services/rrs-product-list/rrs-product-list-component.service';
import { RrsProductSearchService } from '@app/custom/features/rrs-product-listing/services/rrs-product-search/rrs-product-search.service';
import { RrsSearchModule } from '@app/custom/features/rrs-search/rrs-search.module';
import { RrsStarRatingModule } from '@app/custom/features/rrs-star-rating/rrs-star-rating.module';
import { RrsAccordionModule, RrsIconModule } from '@app/shared/components';
import { RrsTagsModule } from '@app/shared/components/rrs-tag/rrs-tags.module';
import { RrsSharedDirectivesModule } from '@app/shared/directives';
import { RrsSharedPipesModule } from '@app/shared/pipes';
import {
  CmsConfig,
  I18nModule,
  ProductSearchService,
  provideConfig,
  UrlModule,
} from '@spartacus/core';
import {
  FacetService,
  KeyboardFocusModule,
  ListNavigationModule,
  PageSlotModule,
  ProductListComponentService,
} from '@spartacus/storefront';

@NgModule({
  declarations: [
    RrsProductListingComponent,
    RrsFacetComponent,
    RrsFacetListComponent,
    RrsActiveFacetsComponent,
    RrsFacetListButtonComponent,
    RrsStoreFacetComponent,
    RrsPlpItemImageSrcPipe,
    RrsDialogActiveFacetsComponent,
  ],
  imports: [
    CommonModule,
    PageSlotModule,
    RrsPaginationModule,
    I18nModule,
    RrsProductCardModule,
    ListNavigationModule,
    RrsSearchModule,
    RouterModule,
    ReactiveFormsModule,
    KeyboardFocusModule,
    RrsAccordionModule,
    RrsIconModule,
    RrsStarRatingModule,
    RrsTagsModule,
    UrlModule,
    RrsSharedDirectivesModule,
    RrsSharedPipesModule,
  ],
  providers: [
    provideConfig({
      slots: {
        ProductList: ['ProductListComponent'],
      },
    } as CmsComponentsConfig),
    provideConfig({
      cmsComponents: {
        ProductListComponent: {
          component: RrsProductListingComponent,
        },
      },
    } as CmsConfig),
    {
      provide: ProductListComponentService,
      useExisting: RrsProductListComponentService,
    },
    {
      provide: FacetService,
      useExisting: RrsFacetService,
    },
    provideConfig(rrsViewConfig),

    {
      provide: ProductSearchService,
      useExisting: RrsProductSearchService,
    },
  ],
})
export class RrsProductListingModule {}
